import init from './init';
import instances from './instances';
import requests from './requests';

const api = { init, instances, requests };

export default api;
